import React, { useEffect, useState } from 'react';

const FUNNY_MESSAGES = [
  'Deciphering your chicken scratch...',
  'Convincing the receipt to cooperate...',
  'Calculating tip math...',
  'Translating coffee stains...',
  'Negotiating with crumpled paper...',
  'Reading between the grease spots...',
];

interface Props {
  message?: string;
}

export default function LoadingAnimation({ message }: Props) {
  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    if (message) return;
    const interval = setInterval(() => {
      setMsgIndex((prev) => (prev + 1) % FUNNY_MESSAGES.length);
    }, 2500);
    return () => clearInterval(interval);
  }, [message]);

  const displayMessage = message || FUNNY_MESSAGES[msgIndex];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '24px 0' }}>
      <style>{`
        @keyframes receiptScan {
          0%, 100% { top: 8px; }
          50% { top: 132px; }
        }
        @keyframes receiptFadeMsg {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>

      {/* Receipt container */}
      <div style={{
        position: 'relative',
        width: 120,
        height: 160,
        background: 'white',
        borderRadius: '4px 4px 0 0',
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        overflow: 'hidden',
        border: '1px solid #e2e8f0',
      }}>
        {/* Fake text lines */}
        <div style={{ padding: '16px 14px 0' }}>
          <div style={{ height: 6, background: '#e2e8f0', borderRadius: 3, marginBottom: 10, width: '80%' }} />
          <div style={{ height: 6, background: '#e2e8f0', borderRadius: 3, marginBottom: 10, width: '100%' }} />
          <div style={{ height: 6, background: '#e2e8f0', borderRadius: 3, marginBottom: 10, width: '60%' }} />
          <div style={{ height: 6, background: '#e2e8f0', borderRadius: 3, marginBottom: 10, width: '90%' }} />
          <div style={{ height: 6, background: '#e2e8f0', borderRadius: 3, marginBottom: 10, width: '45%' }} />
          <div style={{ height: 6, background: '#e2e8f0', borderRadius: 3, marginBottom: 10, width: '75%' }} />
          <div style={{ height: 6, background: '#e2e8f0', borderRadius: 3, marginBottom: 10, width: '55%' }} />
          <div style={{ height: 6, background: '#e2e8f0', borderRadius: 3, width: '85%' }} />
        </div>

        {/* Scan line */}
        <div style={{
          position: 'absolute',
          left: 0,
          right: 0,
          height: 2,
          background: 'linear-gradient(90deg, transparent, #3b82f6, #10b981, #3b82f6, transparent)',
          boxShadow: '0 0 8px rgba(59,130,246,0.5)',
          animation: 'receiptScan 2s ease-in-out infinite',
          top: 8,
        }} />
      </div>

      {/* Zigzag bottom edge */}
      <svg width="120" height="10" viewBox="0 0 120 10" style={{ display: 'block', marginTop: -1 }}>
        <path
          d="M0,0 L6,8 L12,0 L18,8 L24,0 L30,8 L36,0 L42,8 L48,0 L54,8 L60,0 L66,8 L72,0 L78,8 L84,0 L90,8 L96,0 L102,8 L108,0 L114,8 L120,0"
          fill="white"
          stroke="#e2e8f0"
          strokeWidth="1"
        />
      </svg>

      {/* Message below */}
      <p style={{
        marginTop: 16,
        fontSize: 13,
        color: '#666',
        fontStyle: 'italic',
        textAlign: 'center',
        animation: 'receiptFadeMsg 2.5s ease-in-out infinite',
      }}>
        {displayMessage}
      </p>
    </div>
  );
}
